import BannerListPage from "./BannerListPage";

export default function Banner() {
  return (
    <BannerListPage
      pageTitle="Banner List"
      breadcrumbTitle="Banner"
      addPath="/banner-add"
      addLabel="Add Banner"
      editBasePath="/banner-edit"
      bannerType="main"
    />
  );
}
